/**
  * @function evalute - evaluate currentDateBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  // defaultTime is optional and should be in the 24hr time format
  // where 00:00 is 12AM and 23:59 is 11:59PM
  const defaultTime = await sourceEvaluator(source.defaultTime);
  const currentDate = new Date();
  // timeFormatRegex should confirm the 24hr time format is valid.
  const timeFormatRegex = /^([01]\d|2[0-3]):?([0-5]\d)$/;

  // If default time has a value and matches the 24hr time
  // format then update the time on the current date.
  if (defaultTime && timeFormatRegex.test(defaultTime)) {
    currentDate.setHours(defaultTime.split(':')[0]);
    currentDate.setMinutes(defaultTime.split(':')[1]);
    currentDate.setSeconds('0');
    currentDate.setMilliseconds('0');
  }
  return currentDate.toISOString();
};
module.exports = {
  evaluate
};